import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "standard_undetermined_sentiment",
  "use": "standard_undetermined_sentiment-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"standard_undetermined_sentiment\"><circle cx=\"12\" cy=\"12\" r=\"9\" stroke=\"#9AA0A5\" stroke-width=\"2\" /><path d=\"M6 11h4M14 11h4\" stroke=\"#9AA0A5\" stroke-width=\"1.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol